<div class="product_img wrapper imgCantainer w-100">
  <ng-container *ngIf="!isBase64Resource">
    <owl-carousel-o [options]="carouselCustomOption">
      <ng-template carouselSlide class="item"  [id]="i" *ngFor="let img of displayImages?.length ? displayImages : [{}] ;let i = index">
        <img [style.height]="imageHeight + 'rem'" [ngClass]="{'cursorPointer': img}"
        [src]="img ? isBase64Image(img?.imageUrl) : './assets/images/icDiamondPreview.png'"
        onerror="this.src = './assets/images/icDiamondPreview.png'" alt="" (click)="onImageClick()">
      </ng-template>
    </owl-carousel-o>
  </ng-container>

  <ng-container *ngIf="isBase64Resource">
    <owl-carousel-o [options]="carouselCustomOption">
      <ng-template carouselSlide class="item" [id]="i" *ngFor="let img of displayImages?.length ? displayImages : [{}] ;let i = index">
        <img [style.height]="imageHeight + 'rem'" [ngClass]="{'cursorPointer': img}"
        [src]="img ? isBase64Image(img?.base64Resource) : './assets/images/no_preview_image.png'"
        onerror="this.src = './assets/images/no_preview_image.png'" alt="" (click)="onImageClick()">
      </ng-template>
    </owl-carousel-o>
  </ng-container>
</div>